import { render, staticRenderFns } from "./DemoIndex.vue?vue&type=template&id=1befed87&scoped=true&"
import script from "./DemoIndex.vue?vue&type=script&lang=js&"
export * from "./DemoIndex.vue?vue&type=script&lang=js&"
import style0 from "./DemoIndex.vue?vue&type=style&index=0&id=1befed87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1befed87",
  null
  
)

export default component.exports